import { render, staticRenderFns } from "./CouponProgramHistoryDetail.vue?vue&type=template&id=1cab5fe8"
import script from "./CouponProgramHistoryDetail.vue?vue&type=script&lang=js"
export * from "./CouponProgramHistoryDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports